module.exports = __webpack_public_path__ + "static/assets/8fb27bc07c64def488d712e06906c7a4.svg";